import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import { ProductPaginatedResult } from '@shared/types/result';
import { ShippingAddressUpdatePayload } from '@shared/types/cart/Checkout';
import { CommercetoolsSdk } from '../Integration';

export type CheckoutReviewActions = {
    details: any;
    orderDetails: any;
    updateShipmentDetails: any;
};

export const getCheckoutReviewActions = (sdk: CommercetoolsSdk<ComposableCommerceEventsB2B>): CheckoutReviewActions => {
    return {
        details: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-review/details',
                payload: {
                    ...payload,
                },
            });
            return response;
        },
        orderDetails: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-review/orderDetails',
                payload: {
                    ...payload,
                },
            });
            return response;
        },

        updateShipmentDetails: async (payload: ShippingAddressUpdatePayload) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-review/updateShipmentDetails',
                payload: {
                    ...payload,
                },
            });
            return response;
        }
    };
};
